import React from 'react';
import {DraggableComponentProps} from '../models';
import {DroppableReactContext} from '../droppable/DroppableReactContext';
import {DroppableStore} from '../droppable/DroppableStore';
import {DraggableImpl} from './DraggableImpl';

export class Draggable extends React.Component<DraggableComponentProps> {
  render() {
    return (
      <DroppableReactContext.Consumer>
        {
          this.childRenderer
        }
      </DroppableReactContext.Consumer>
    );
  }

  childRenderer = (store: DroppableStore | null) => {
    if (store === null)
      return (
        <div className="alert alert-danger">
          <b>Draggable</b> must have <b>DroppableReactContext</b> as parent.
        </div>);

    const draggableId = this.props.draggableId;
    const {children, ...rest} = this.props;

    return (
      <DraggableImpl key={draggableId}
                     {...rest}
                     droppableStore={store}>
        {children}
      </DraggableImpl>)
      ;

  };
}

